import React from "react"
import { TSaleProduct } from "../../../../../core/types/Sale"
import OrderItem6 from "./OrderItem8"

interface IOrderProduct8Prop {
  paymentMethodType: number
  installmentNumber: number
  product: TSaleProduct
}

const OrderProduct8 = ({
  paymentMethodType,
  installmentNumber,
  product,
}: IOrderProduct8Prop) => {
  return (
    <OrderItem6
      key={product.id}
      paymentMethodType={paymentMethodType}
      installmentNumber={installmentNumber}
      description={product.productName}
      value={product.firstPurchasePrice || product.value}
      defaultValue={product.firstPurchasePrice || product.value}
      installments={product.installments}
      typePayment={product.typePayment}
      frequency={product.frequency}
    />
  )
}

export default OrderProduct8
